import CustomStore from "devextreme/data/custom_store";
import jwtService from "@service/jwt-service";
const Axios = jwtService.axiosIns;

import { CommonUtil } from "@utils/CommonUtil";
import { UserConst } from "@constants/user-const";
import DataSource from "devextreme/data/data_source";
import { CommonConst } from "@constants/common-const";
import { commonNotify } from "@utils/common";

//----------------------------------
// 사용자 프로필
//----------------------------------

type BusinessUserResponse = {
  data: BusinessUser;
};

// 사용자 프로필 조회
const _getMyProfile = () => {
  return Axios.get<BusinessUser>("/users/profile");
};

// (전문설계 조회) 사용자 프로필 조회
const getDesignUserProfile = () => {
  return Axios.get("/users/profile/all");
};

// 사용자 프로필 수정
const updateUserProfile = (...args: any[]) => {
  return Axios.put("/users/profile", ...args);
};

// 사용자 프로필 비밀번호 수정
const updateUserProfilePassword = (...args: any[]) => {
  return Axios.put("/users/profile/password", ...args);
};

//----------------------------------
// 사용자 - 조직원(비즈니스 사용자)
//----------------------------------

// 조직원 목록 조회
const getEmployees = (params: any) => {
  return Axios.get(`/employees?${params}`);
};

// 조직원 목록 조회 - 조직별(운영자)
const getCompanyEmployees = (companyId: number, params: any) => {
  return Axios.get(`/companies/${companyId}/employees?${params}`);
};

// 조직원 목록 검색 조회
const getEmployeeSearch = (params: any) => {
  return Axios.get(`/employees/search?${params}`);
};

// 조직원 목록 검색 조회 - 조직별(운영자)
const getCompanyEmployeeSearch = (companyId: number, params: any) => {
  return Axios.get(`/companies/${companyId}/employees/search?${params}`);
};

// 조직원 등록
const createEmployee = (...args: any[]) => {
  return Axios.post("/employees", ...args);
};

// 조직원 등록 - 조직별(운영자)
const createCompanyEmployee = (companyId: any, ...args: any[]) => {
  return Axios.post(`/companies/${companyId}/employees`, ...args);
};

// 조직원 조회
const _getEmployee = (username: any) => {
  return Axios.get(`/employees/${username}`);
};

// 조직원 조회 - 조직별(운영자)
const getCompanyEmployee = (companyId: any, username: any) => {
  return Axios.get(`/companies/${companyId}/employees/${username}`);
};

// 조직원 수정
const updateEmployee = (username: any, ...args: any) => {
  return Axios.put(`/employees/${username}`, ...args);
};

// 조직원 수정 - 조직별(운영자)
const updateCompanyEmployee = (companyId: any, username: any, ...args: any) => {
  return Axios.put(`/companies/${companyId}/employees/${username}`, ...args);
};

// 조직원 비밀번호 수정
const updateEmployeePassword = (username: string, ...args: any) => {
  return Axios.put(`/employees/${username}/password`, ...args);
};

// 조직원 비밀번호 수정 - 조직별(운영자)
const updateCompanyEmployeePassword = (companyId: number, username: string, ...args: any) => {
  return Axios.put(`/companies/${companyId}/employees/${username}/password`, ...args);
};

// 조직원 삭제
const _deleteEmployee = (username: string) => {
  return Axios.delete(`/employees/${username}`);
};

// 조직원 삭제 - 조직별(운영자)
const _deleteCompanyEmployee = (companyId: string, username: string) => {
  return Axios.delete(`/employees/${companyId}/employees/${username}`);
};

//----------------------------------
// 사용자 - 전체 비즈니스 사용자 (운영자 기능)
//----------------------------------

// 비즈니스 사용자 목록 조회
const getBusinessUsers = (params: string) => {
  return Axios.get(`/users/businessusers/?${params}`);
};

// 비즈니스 사용자 등록
const createBusinessUser = (...args: any) => {
  return Axios.post("/users/businessusers", ...args);
};

// 비즈니스 사용자 조회
const _getBusinessUser = (username: string) => {
  return Axios.get(`/users/businessusers/${username}`);
};

// 비즈니스 사용자 수정
const updateBusinessUser = (username: string, ...args: any) => {
  return Axios.put(`/users/businessusers/${username}`, ...args);
};

// 비즈니스 사용자 비밀번호 수정
const updateBusinessUserPassword = (...args: any) => {
  return Axios.put("/users/businessusers/password", ...args);
};

// 비즈니스 사용자 역할 조회
const getBusinessUserRole = (username: any) => {
  return Axios.get(`/users/businessusers/role/${username}`);
};

//----------------------------------
// 사용자 프로필
//----------------------------------

/**
 * 내 프로필 조회
 */
export async function getMyProfile() {
  let result = null;
  let businessUser = null;
  // store.commit("store/setLoading", true);
  // store.commit("store/setLoadMessage", "잠시만 기다려주세요."); // 불러오기

  try {
    result = await _getMyProfile();

    businessUser = result.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
    // store.commit("store/setLoadMessage", "잠시만 기다려주세요.");
  }

  return businessUser;
}

/**
 * 내 프로필 수정
 */
export async function updateMyProfile(updateUser: any) {
  // store.commit("store/setLoading", true);
  // store.commit("store/setLoadMessage", "잠시만 기다려주세요."); // 불러오기

  // JSON화
  const jsonData: string = JSON.stringify(updateUser);

  try {
    await updateUserProfile(jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    commonNotify(CommonConst.completeSave);
  } catch (e) {
    commonNotify(CommonConst.errorSave, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
    // store.commit("store/setLoadMessage", "잠시만 기다려주세요.");
  }
}

//----------------------------------
// 비즈니스 사용자 = 조직원
//----------------------------------

/**
 * 조직원 목록 조회(Dx)
 */
export function getEmployeeDataSource(accessType: string = "", companyId: number) {
  let result = null;
  return new CustomStore({
    key: "id",
    onLoading() {
      // store.commit("store/setLoading", true);
    },
    onLoaded() {
      // store.commit("store/setLoading", false);
    },
    load(loadOptions) {
      // 파라미터 생성
      const params = CommonUtil.makeDxDataGridParams(loadOptions);

      if (accessType === CommonConst.ACCESS_TYPE_MY) {
        result = getEmployees(params);
      } else {
        result = getCompanyEmployees(companyId, params);
      }
      return result
        .then((response: any) => ({
          data: response.data.data,
          totalCount: response.data.totalCount,
        }))
        .catch(() => {
          // store.commit("store/setLoading", false);
          throw new Error("Data Loading Error");
        });
    },
  });
}

/**
 * 조직원 목록 검색 조회(Dx)
 * 설계 상세 화면에서 견적자 목록 검색
 */
export function getEmployeeSearchDataSource(
  accessType: string,
  companyId: number = null,
  accountStatus?: string,
  workStatus?: string,
) {
  let result: any = null;
  let keyResult: any = null;
  return new DataSource({
    paginate: false,
    store: new CustomStore({
      key: "username",
      loadMode: "processed",
      load: (loadOptions: any) => {
        if (accessType === CommonConst.ACCESS_TYPE_COMPANY && loadOptions.searchValue === null) {
          loadOptions.searchValue = "";
        }
        let params = `search=${loadOptions.searchValue}&accountStatus=${accountStatus}&workStatus=${workStatus}`;
        if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
          result = getCompanyEmployeeSearch(companyId, params);
        } else if (accessType === CommonConst.ACCESS_TYPE_MY) {
          result = getEmployeeSearch(params);
        }
        return result.then((response: any) => response.data);
      },
      byKey: key => {
        if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
          keyResult = getCompanyEmployee(companyId, key);
        } else if (accessType === CommonConst.ACCESS_TYPE_MY) {
          keyResult = _getEmployee(key);
        }
        return keyResult.then((response: any) => response.data);
      },
      cacheRawData: false,
      useDefaultSearch: false,
    }),
  });
}

export async function getEmployee(accessType: string = null, companyId: number = null, username: string = "") {
  let result = null;
  let businessUser = null;

  // store.commit("store/setLoading", true);
  // store.commit("store/setLoadMessage", "잠시만 기다려주세요."); // 불러오기

  try {
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      // 조직원 조회
      result = await _getEmployee(username);
      businessUser = result.data;
    } else {
      // 조직원 조회 - 조직별(운영자)
      result = await getCompanyEmployee(companyId, username);
      businessUser = result.data;
    }
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
    // store.commit("store/setLoadMessage", "잠시만 기다려주세요.");
  }

  return businessUser;
}

/**
 * 조직원 등록/수정
 * @param accessType
 * @param modifyType
 * @param companyId
 * @param username
 * @param businessUser
 */
export async function saveEmployee(
  accessType: string = "",
  modifyType: string = null,
  companyId: number = null,
  username: string = "",
  businessUser: BusinessUser = null,
) {
  // store.commit("store/setLoading", true);
  // store.commit("store/setLoadMessage", "잠시만 기다려주세요."); // 저장

  // JSON화
  const jsonData: string = JSON.stringify(businessUser);

  // 통신
  try {
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      if (modifyType === CommonConst.MODIFY_TYPE_CREATE) {
        // 조직원 등록
        await createEmployee(jsonData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        commonNotify(CommonConst.completeSave);
      } else {
        // 조직원 수정
        await updateEmployee(username, jsonData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        commonNotify(CommonConst.completeUpdate);
      }
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      if (modifyType === CommonConst.MODIFY_TYPE_CREATE) {
        // 조직원 등록 - 조직별(운영자)
        await createCompanyEmployee(companyId, jsonData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        commonNotify(CommonConst.completeSave);
      } else {
        // 조직원 수정 - 조직별(운영자)
        await updateCompanyEmployee(companyId, username, jsonData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        commonNotify(CommonConst.completeUpdate);
      }
    }
  } catch (e: any) {
    commonNotify(CommonConst.errorSave, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
    // store.commit("store/setLoadMessage", "잠시만 기다려주세요.");
  }
}

/**
 * (사용 안함) 조직원 삭제
 */
export function deleteEmployee(username: string) {
  // 통신
  _deleteEmployee(username)
    .then((response: any) => {
      commonNotify(CommonConst.completeDelete);
    })
    .catch((e: any) => {
      commonNotify(CommonConst.errorGet, "error");
      throw e;
    });
}

/**
 * (사용 안함) 조직원 삭제 - 조직별(운영자)
 */
export function deleteCompanyEmployee(username: string) {
  // 통신
  // _deleteCompanyEmployee(username)
  //   .then((response: any) => {
  //     this.errors = false;
  //
  //     notify({message:"삭제가 완료되었습니다.", position: { at: "top center", offset: { x: 0, y: 44 }, my: "top center" },
  //     });
  //   })
  //   .catch((e: any) => {
  //     this.errors = true;
  //     this.errors.push(e);
  //     console.log(`[오류]:${this.errors}`);
  //     notify({message:"조회중 오류가 발생했습니다!!", position: { at: "top center", offset: { x: 0, y: 44 }, my: "top center" },
  //     });
  //     throw e;
  //   });
}

//----------------------------------
// 사용자 - 전체 비즈니스 사용자 (운영자 기능)
//----------------------------------

/**
 * 비즈니스 사용자 목록 조회(Dx)
 */
export function getBusinessUserDataSource() {
  return new CustomStore({
    key: "id",
    onLoading() {
      // store.commit("store/setLoading", true);
    },
    onLoaded() {
      // store.commit("store/setLoading", false);
    },
    load(loadOptions) {
      // 파라미터 생성
      const params = CommonUtil.makeDxDataGridParams(loadOptions);
      return getBusinessUsers(params)
        .then((response: any) => ({
          data: response.data.data,
          totalCount: response.data.totalCount,
        }))
        .catch(() => {
          // store.commit("store/setLoading", false);
          throw new Error("Data Loading Error");
        });
    },
  });
}

/**
 * 비즈니스 사용자 조회
 * @param username 비즈니스 사용자 아이디
 */
export async function getBusinessUser(username: string) {
  let result = null;
  let businessUser = null;

  // store.commit("store/setLoading", true);
  // store.commit("store/setLoadMessage", "잠시만 기다려주세요."); // 불러오기

  try {
    result = await _getBusinessUser(username);

    businessUser = result.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
    // store.commit("store/setLoadMessage", "잠시만 기다려주세요.");
  }

  return businessUser;
}

/**
 * 비즈니스 사용자 저장
 * @param modifyType 수정형태
 * @param username 사용자 아이디
 * @param businessUser
 */
export async function saveBusinessUser(
  modifyType: string = "",
  username: string = null,
  businessUser: BusinessUser = null,
) {
  // store.commit("store/setLoading", true);
  // store.commit("store/setLoadMessage", "잠시만 기다려주세요."); // 저장

  // JSON화
  const jsonData: string = JSON.stringify(businessUser);

  try {
    if (modifyType === CommonConst.MODIFY_TYPE_CREATE) {
      // [등록]
      await createBusinessUser(jsonData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      commonNotify(CommonConst.completeSave);
    } else {
      // [수정]
      await updateBusinessUser(username, jsonData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      commonNotify(CommonConst.completeUpdate);
    }
  } catch (e) {
    commonNotify(CommonConst.errorSave, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
    // store.commit("store/setLoadMessage", "잠시만 기다려주세요.");
  }
}

/**
 * 비밀번호 수정
 * @param accessType 접근형태
 * @param userType 유저타입
 * @param companyId 조직id
 * @param businessUser 유저 객체
 * @param tempPassword 비밀번호
 * @param tempPasswordConfirm 비밀번호 확인
 * @param username 아이디
 * @param isProfile 내 프로필 여부
 */
export async function updatePassword(
  accessType: string = "",
  userType: string = "",
  companyId: number = null,
  businessUser: BusinessUser = null,
  tempPassword = "",
  tempPasswordConfirm = "",
  username = "",
  isProfile: boolean = false,
) {
  const newData = {
    ...businessUser,
    password: tempPassword,
    passwordConfirm: tempPasswordConfirm,
  };
  // store.commit("store/setLoading", true);
  // JSON화
  const jsonData: string = JSON.stringify(newData);

  try {
    if (isProfile) {
      // 내 프로필 비밀번호 수정
      await updateUserProfilePassword(jsonData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      commonNotify(CommonConst.completeUpdate);
    } else {
      if (userType === UserConst.userType.EMPLOYEE) {
        if (accessType === CommonConst.ACCESS_TYPE_MY) {
          // 조직원 비밀번호 수정
          await updateEmployeePassword(username, jsonData, {
            headers: {
              "Content-Type": "application/json",
            },
          });

          commonNotify(CommonConst.completeUpdate);
        } else {
          // 조직원 비밀번호수정 - 조직별(운영자)
          await updateCompanyEmployeePassword(companyId, username, jsonData, {
            headers: {
              "Content-Type": "application/json",
            },
          });

          commonNotify(CommonConst.completeUpdate);
        }
      } else if (userType === UserConst.userType.BUSINESS) {
        // 비즈니스 사용자 비밀번호 수정
        await updateBusinessUserPassword(jsonData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        commonNotify(CommonConst.completeUpdate);
      }
    }
  } catch (e) {
    commonNotify(CommonConst.errorSave, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}
